import(/* webpackMode: "eager", webpackExports: ["SubscriptionPageClient"] */ "/app/apps/galatea-web/src/app/[locale]/(navbar)/p/subscription/components/SubscriptionPageClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/utils-web/src/lib/common/i18n/LanguageChangeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/utils-web/src/lib/common/i18n/TranslationsClientProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@unleash/nextjs/dist/FlagProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@unleash/nextjs/dist/hooks.js");
